import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  AfterViewInit,
} from '@angular/core';
import { AccountRepositoryService } from 'app/account-repository.service';
import { AppComponent } from 'app/app.component';
import { ExpressyonService } from 'app/expressyon.service';
@Component({
  selector: 'app-password-protected',
  templateUrl: './password-protected.component.html',
  styleUrls: ['./password-protected.component.scss'],
})
export class PasswordProtectedComponent implements OnInit, AfterViewInit {
  isProtected: boolean = true;
  password;
  error: Boolean = false;
  customPlaceHolder;
  constructor(
    private accountRepository: AccountRepositoryService,
    private expressyonService: ExpressyonService
  ) {}

  ngOnInit() {
    if (!this.expressyonService.hasDefaultPassword()) {
      this.customPlaceHolder = ' ';
    } else {
      this.customPlaceHolder = 'Defaut: 1111';
    }
  }

  focus(event) {
    AppComponent.scrollIntoView(event.target);
  }

  ngAfterViewInit(): void {
    AppComponent.setMainInput(document.getElementById('password'));
  }

  @Output() protectionChange = new EventEmitter<Boolean>();

  unlock(password) {
    if (!this.expressyonService.validatePassword(password)) {
      this.error = true;
      this.password = '';
      return;
    }
    this.isProtected = false;
    this.protectionChange.emit(false);
  }
}
